import { createRequestActionsSet } from "@store/shared/requestState"

export const fetchUserOrgs = createRequestActionsSet("orgs", "FETCH_USER_ORGS")
